import { createSlice } from "@reduxjs/toolkit";

import { techTextLedger } from "./communicationActions";

const initialState = {
  loading: false,
};

const communicationSlice = createSlice({
  name: "communication",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(techTextLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(techTextLedger.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(techTextLedger.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default communicationSlice.reducer;
